export default {
  name: 'zh-cn',
  ep: {
    dialog: {
      cancel: '取消',
      confirm: '确定',
      title: '提示',
    },
    buttons: {
      cancel: '取消',
      confirm: '确定',
      secondConfirm: '确定要',
      secondConfirmEnd: '吗',
      prompt: '提示',
    },
    input: {
      placeholder: '请输入',
    },
    datePickerRange: {
      lastWeek: '最近一周',
      lastMonth: '最近一个月',
      lastThreeMonth: '最近三个月',
      startTime: '开始时间',
      endTime: '结束时间',
    },
    formItem: {
      required: '不能为空',
    },
    form: {
      more: '更多',
      collapse: '收起',
    },
    header: {
      save: '保存',
      edit: '修改',
      cancel: '取消',
      refresh: '刷新',
      approvalLog: '审批日志',
    },
    searchListPage: {
      add: '新增',
      templateDownload: '模版下载',
      import: '导入',
      export: '导出',
      search: '搜索',
      clear: '清空',
    },
    table: {
      select: '选择',
      serialNumber: '序号',
      operation: '操作',
    },
    title: {
      collapse: '折叠',
      expand: '展开',
    },
    chooseDialog: {
      selected: '已选中',
      unit: '个',
    },
    customColumn: {
      columnSettings: '自定义列设置',
      defineColumn: '自定义列',
      hiddenField: '隐藏字段',
      visibleField: '显示字段',
      moveLeft: '左移',
      moveRight: '右移',
      moveUp: '上移',
      moveDown: '下移',
    },
    bpm: {
      approvalLog: '审批日志',
    },
    loading: {
      loading: '正在加载中...',
    },
    http: {
      networkError: '网络异常，请检查您的网络连接后重试',
      timeout: '请求超时，请稍后再试',
      requestError: '请求错误。请检查您的输入并重试',
      authExpired: '登录认证过期，请重新登录后继续',
      forbidden: '禁止访问, 您没有权限访问此资源',
      notFound: '未找到, 请求的资源不存在', //
      serverError: '内部服务器错误，请稍后再试',
    },
    attachment: {
      addAttachment: '添加附件',
      manageAttachment: '附件管理',
      operation: '操作',
      download: '下载',
      delete: '删除',
      attachmentType: '附件类型',
      fileName: '文件名称',
      creator: '创建人',
      createTime: '创建时间',
      description: '说明',
    },
  },
}
